import { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavBarContext } from '../App';
import { storeRedirectPathTo } from '../util/redirectUtils';

const STUDIO_ERSTELLEN_PATH = '/studio-erstellen';
const STUDIO_ERSTELLEN_TO = 'studio-erstellen';

const useStudioErstellenClick = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const { setShowSignIn, setShowRegister, isPhoneSize } = useContext(NavBarContext);

  return useCallback(() => {
    if (isAuthenticated) {
      navigate(STUDIO_ERSTELLEN_PATH);
      return;
    }

    storeRedirectPathTo(STUDIO_ERSTELLEN_PATH);

    if (isPhoneSize) {
      navigate(`/registrieren?to=${STUDIO_ERSTELLEN_TO}`, {
        state: { to: STUDIO_ERSTELLEN_TO },
      });
      return;
    }

    setShowSignIn(false);
    setShowRegister(true);
  }, [isAuthenticated, isPhoneSize, navigate, setShowRegister, setShowSignIn]);
};

export default useStudioErstellenClick;
